import styled from 'styled-components'
import { flexDirection, FlexDirectionProps, top, TopProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

const shouldForwardProp = (prop: string) => !['flexDirection'].includes(prop)

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

export const Card = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: ${themeGet('space.6')}px;
  align-items: stretch;

  img {
    object-fit: cover;
    border-radius: 16px;
  }

  ${flexDirection}
`

export const NumberBadge = styled.div<TopProps>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 25px;
  background-color: ${themeGet('colors.background.badge')};
  z-index: 1;

  ${top}
`

export const Line = styled.div`
  width: 2px;
  flex-grow: 1;
  background-color: ${themeGet('colors.line.tertiary')};
  transform: translateY(16px);
`
